<script>

import {round} from "lodash";

export default {
  name: "overview",
  components: {},
  props: {
    revenue: {type: Number, default: 0},
    netProfit: {type: Number, default: 0},
    quantity: {type: Number, default: 0},
  },
  computed: {
    formattedRevenue() {
      return this.$numeral(this.revenue).format('$ 0,0.[00]')
    },
    formattedNetProfit() {
      return this.$numeral(this.netProfit).format('$ 0,0.[00]')
    },
    formattedQuantity() {
      return this.$numeral(round(this.quantity / 1000, 2)).format('0,0.[00]')
    },
    isAllEmpty() {
      return !this.revenue && !this.netProfit && !this.quantity;
    }
  }
}
</script>

<template>
  <div class="col-12">
    <b-card no-body class="mb-4">
      <b-card-body>
        <h3 class="dashboard-card-header mb-2">Ringkasan</h3>

        <b-row v-if="!isAllEmpty">
          <!-- Total Tonase -->
          <b-col cols="12" md="4" class="mb-3 mb-md-0">
            <b-card>
              <div class="d-flex justify-content-between align-items-center">
                <span class="overview-card-title">Total Tonase</span>
                <img src="@/assets/icons/ScaleIcon.svg" alt="Quantity Icon"/>
              </div>
              <div class="overview-card-body mt-4">
                {{ formattedQuantity }} <span style="color: #667085; font-weight: 500">ton</span>
              </div>
            </b-card>
          </b-col>

          <!-- Total Revenue -->
          <b-col cols="12" md="4" class="mb-3 mb-md-0">
            <b-card>
              <div class="d-flex justify-content-between align-items-center">
                <span class="overview-card-title">Total Revenue</span>
                <img src="@/assets/icons/RupiahUpIcon.svg" alt="Revenue Icon"/>
              </div>
              <div class="overview-card-body mt-4">
                {{ formattedRevenue }}
              </div>
            </b-card>
          </b-col>

          <!-- Total Net Profit -->
          <b-col cols="12" md="4">
            <b-card>
              <div class="d-flex justify-content-between align-items-center">
                <span class="overview-card-title">Total Net Profit</span>
                <img src="@/assets/icons/RupiahFileIcon.svg" alt="Revenue Icon"/>
              </div>
              <div class="overview-card-body mt-4">
                {{ formattedNetProfit }}
              </div>
            </b-card>
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col cols="12">
            <b-card class="overview-empty-card-body m-0" style="background-color: #F2F4F7; border-color: #EAECF0; border-radius: 0; box-shadow: none">
              <b-card-body class="text-center">
                Tidak ada data<br>dari filter yang diterapkan
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<style scoped lang="scss">
.overview-card-title {
  color: #667085;
  font: 500 16px/24px Inter;
}
.overview-card-body {
  color: #1664D8;
  font: 800 20px/28px Inter;
}
.overview-empty-card-body {
  font: 400 12px/18px Inter;
}
</style>